export const SHIPMENT = [
  { key: "scheduled", label: "Scheduled", color: "bg-slate-100 text-slate-600 border-slate-200" },
  { key: "picked_up", label: "Picked up", color: "bg-blue-50 text-blue-700 border-blue-200" },
  { key: "in_transit", label: "In transit", color: "bg-amber-50 text-amber-700 border-amber-200" },
  { key: "delivered", label: "Delivered", color: "bg-green-50 text-green-700 border-green-200" },
];
export const shipmentOrder = { scheduled: 0, picked_up: 1, in_transit: 2, delivered: 3 };
export const shipmentMeta = (k) => SHIPMENT.find((s) => s.key === k) || SHIPMENT[0];
